import React from 'react';
import { observer } from 'mobx-react';
import Link from '@mui/material/Link';
import { FlexDiv, TextDefault } from '@awarego-ui/components';
import ThemedSpinner from '../themed/ThemedSpinner';

/**
 * Universal image display with a remove link.
 *
 * Props:
 *   src       – full image URL
 *   alt       – img alt text
 *   onRemove  – callback when user clicks Remove
 *   removing  – boolean from the store's removing flag; shows spinner while true
 *   maxWidth  – CSS max-width (default: '280px')
 *   maxHeight – CSS max-height (default: '200px')
 *   pixelated – pixelated image rendering for favicons
 */
function ImageDisplay({
    src,
    alt,
    onRemove,
    removing = false,
    maxWidth = '280px',
    maxHeight = '200px',
    pixelated = false,
}) {
    return (
        <FlexDiv
            column
            alignCenter
            justifyCenter
            style={{ minHeight: '200px' }}
        >
            <img
                src={src}
                alt={alt}
                style={{
                    maxWidth,
                    maxHeight,
                    objectFit: 'contain',
                    imageRendering: pixelated ? 'pixelated' : 'auto',
                    marginBottom: '16px',
                }}
            />
            {onRemove && (
                removing ? (
                    <div style={{ marginTop: '-20px', marginBottom: '-20px' }}>
                        <ThemedSpinner size={40} />
                    </div>
                ) : (
                    <Link component="button" onClick={onRemove}>
                        <TextDefault error bold>
                            Remove
                        </TextDefault>
                    </Link>
                )
            )}
        </FlexDiv>
    );
}

export default observer(ImageDisplay);
